import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Space, Button } from 'antd';
import { LogoImage } from 'utils/imageConstants';
import { referenceTypePagination } from 'services/redux/Reference/action';

const TypeAddUpdateTable = ({ showAddUpdateTypeDrawer }) => {
	const columns = [
		{
			title: 'S No',
			key: "sno",
			render: (text, object, index) => index + 1,
			width:"5%",
		},

		{
			title: 'Refernce Type',
			dataIndex: 'referenceTypeName',
			key: 'referenceTypeName',
		},
		{
			title: 'Reference Symbol',
			dataIndex: 'symbol',
			key: 'symbol',
		},

		{
			title: 'Action',
			key: 'action',
			render: (record) => (
				<a className="action-btn action-btn-add" onClick={(e) => showAddUpdateTypeDrawer(e, record)}>
					Edit Type
				</a>
			),
		},
	];

	const dispatch = useDispatch();
	const { referenceTypePaginationResponse, referenceTypePaginationLoading } = useSelector((state) => state.reference);

	const [data, setdata] = useState([]);
	const [totalCount, setTotalCount] = useState(10);
	const pageSize = 10;

	useEffect(() => {
		getData();
	}, []);

	useEffect(() => {
		if (!referenceTypePaginationResponse) return;
		setdata(referenceTypePaginationResponse.items);
		setTotalCount(referenceTypePaginationResponse.totalCount);
	}, [referenceTypePaginationResponse]);

	const getData = (MaxResultCount = pageSize, SkipCount = 0, Sorting, SortType) => {
		dispatch(
			referenceTypePagination({
				MaxResultCount,
				SkipCount,
				Sorting,
				SortType,
			})
		);
	};

	const handleTableChange = (pagination, filters, sorter, extra) => {
		let Sorting = sorter.columnKey;
		let SortType = sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : undefined;
		let MaxResultCount = pageSize;
		let SkipCount = (pagination.current - 1) * pagination.pageSize;

		getData(MaxResultCount, SkipCount, Sorting, SortType);
		// getData(pagination.current, pagination.pageSize);
	};

	return (
		<Table
			className="organizer__tables"
			columns={columns}
			rowKey="appUserId"
			dataSource={data}
			onChange={handleTableChange}
			loading={referenceTypePaginationLoading}
			loading={{
				indicator: <img src={LogoImage} height="auto" width="50px" />,
				spinning: referenceTypePaginationLoading,
			}}
			pagination={{
				total: totalCount,
				pageSize: pageSize,
			}}
		/>
	);
};

export default TypeAddUpdateTable;
